import React, { useState, useEffect } from "react";
import { Modal, Box, Typography } from "@mui/material";
import MyButton from "../../components/myButton";
import MyInput from "../../components/myInput";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  height: 400,
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
};

function ModalFinalizaTarefa({ open, onClose, onFinalizar }) {
  const [dataSaida, setDataSaida] = useState("");
  const [descricao, setDescricao] = useState("");

  // Preenche a data com hoje ao abrir o modal
  useEffect(() => {
    if (open) {
      const hoje = new Date()
      const formatada = hoje.toLocaleDateString('en-CA') +' '+ 
                        hoje.toTimeString().slice(0, 5) +':00'     
      setDataSaida(formatada)
      setDescricao("")
    }
  }, [open]);

  const handleConfirmar = () => {
        let data = new Date(dataSaida);
        let pad = (n) => n.toString().padStart(2, '0');
        let dataFormatada = `${pad(data.getDate())}/${pad(data.getMonth() + 1)}/${data.getFullYear()} ${pad(data.getHours())}:${pad(data.getMinutes())}:00`;

    onFinalizar({
      saida: dataFormatada,
      descricao: descricao,
    });
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        <Typography variant="h6" component="h2" gutterBottom>
          Finalizar a tarefa manualmente.
        </Typography>

        <Box sx={{display: 'flex', marginTop:3, flexDirection: 'column', gap: 2, height: '80%' }}>
          <MyInput
            label="Data de Saída do Local"
            type="datetime-local"
            value={dataSaida}
            onChange={(e) => setDataSaida(e.target.value)}
            InputLabelProps={{ shrink: true }}
            fullWidth
          />

          <MyInput
            label="Justifique a finalização da tarefa"
            multiline
            rows={4}
            inputProps={{ maxLength: 250 }}
            value={descricao}
            onChange={(e) => setDescricao(e.target.value)}
            fullWidth
            helperText={`${descricao.length}/250`}
          />
          <Box sx={{ display: 'flex', justifyContent: 'space-between', marginTop: 0 }}>
            <MyButton
              onClick={onClose}
              variant="contained"
              text="Voltar"
              color="warning"
            />
            <MyButton
              onClick={handleConfirmar}
              variant="contained"
              text="Finalizar"
              color="success"
              disabled={descricao.length < 20} 
            />
          </Box>
        </Box>

      </Box>
    </Modal>
  );
}

export default ModalFinalizaTarefa;
